module.exports = __webpack_public_path__ + "img/dummyprod-in-motion@2x.af4540ef.png";